export const SORT_DIRECTIONS = {
  ASC: "ASC",
  DESC: "DESC",
} as const;
